import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useRequest } from '../../../fetchboi/hooks'
import Layout from '../../../components/Layout'
import { Col, Row } from 'rsuite'
import { motion } from 'framer-motion'
import Tabs from './Tabs'
import Map from './Map'
import PlaceSheet from './PlaceSheet'

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.05
    }
  }
}

export default function Location () {
  const [currentPlace, setCurrentPlace] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [places, loading] = useRequest({ url: '/places' })
  const [placeTips, isPlaceTipsLoading] = useRequest({ url: '/placeTips' })

  const handlePlacePress = (place) => {
    setIsLoading(true)
    setCurrentPlace(place)

    setTimeout(() => {
      setIsLoading(false)
    }, 800)
  }

  useEffect(() => {
    if (places && places.length > 0) {
      setCurrentPlace(places[0])
    }
  }, [places])

  return currentPlace ? (
    <Container>
      <Layout.Title>Ubicación</Layout.Title>
      <Layout.Loader loading={loading}/>
      {currentPlace ? (
        <motion.div variants={containerVariants} initial="hidden" animate="visible">
          <TabsContainer>
            <Tabs onChange={handlePlacePress} places={places}/>
          </TabsContainer>
          <Row>
            <Col xs={24} md={16} >
              <Map 
                name={currentPlace.Name} 
                isLoading={isLoading}
              />
            </Col>
            <Col xs={24} md={8} >
            <PlaceSheetContainer>
              <PlaceSheet place={currentPlace} tips={placeTips && placeTips.filter(it => it.PlaceUUID === currentPlace.UUID)}/>
            </PlaceSheetContainer>
            </Col>
          </Row>
        </motion.div>
      ) : <Placeholder />}
    </Container>
  ) : null
}

const Container = styled.div`
  padding-bottom: 20px;
`
const TabsContainer = styled.div`
  width: 100%;
`

const PlaceSheetContainer = styled.div`

`
const Placeholder = styled.div`
  width: 100%;
  height: 450px;
  background-color: #777;
`